import useHistoryLocation from '@/composables/useHistoryLocation'

export default function useLocationAutoSelectFirst(opts?: {
  useHistoryLocation?: any
  store?: any
}) {
  let store: any

  // Lazily initialize the store using dynamic import
  const getStore = async () => {
    if (!store) {
      if (opts?.store) {
        store = opts.store
      } else {
        const storeModule = await import('@/store')
        store = storeModule.default
      }
    }
    return store
  }

  const useHistoryLocationFunc = opts?.useHistoryLocation ?? useHistoryLocation

  const getSelectedItemWrapper = async () => {
    const storeInstance = await getStore()
    const { getSelectedItem } = useHistoryLocationFunc({
      store: storeInstance,
    })
    return getSelectedItem
  }

  const getState = async () => {
    const storeInstance = await getStore()
    return storeInstance.state.location_module
  }

  let scope = {
    /**
     * Inject this into vuex state {...newState()}
     * @returns
     */
    newState() {
      console.debugVerboseScope(6, 'asf', 'asf new state')
      return {
        shouldAutoSelectFirst: false,
      }
    },
    /***
     * Call this at some point to enable auto select
     */
    async enableAutoSelectFirst() {
      const state = await getState()
      state.shouldAutoSelectFirst = true

      console.debugVerboseScope(6, 'asf', 'asf mark true')
    },
    /**
     * Will try to auto select the last selected item
     * @returns
     */
    async autoSelectLast(times: number = 1) {
      const state = await getState()
      if (!state.shouldAutoSelectFirst) {
        return
      }

      console.debugVerboseScope(6, 'asf', 'asf select')

      let item = await (await getSelectedItemWrapper())()
      let id = item?.id
      let results = []
      if (id) {
        results = [
          state.vehicleResults,
          state.driverResults,
          state.circuitResults,
        ]
        for (let i = 0; i < results.length; i++) {
          const result = results[i]
          if (result.length > 0) {
            for (let r of result) {
              if (r.id === id || r.vehicleId === id) {
                console.debugVerboseScope(6, 'asf', 'asf select success', r)
                let selected = { ...r, openSubMenu: true }
                const storeInstance = await getStore()
                storeInstance.dispatch('location_module/selectItem', selected)
                state.shouldAutoSelectFirst = false
                return
              }
            }
          }
        }
      }
      console.debugVerboseScope(6, 'asf', 'asf select fail', {
        id,
        item,
        results,
        times,
      })

      if (times > 0) {
        setTimeout(async () => {
          console.debugVerboseScope(6, 'asf', 'asf retrying', {
            item,
            results,
          })
          await scope.autoSelectLast(times - 1)
        }, 1000)
      }
    },
  }

  return scope
}
